import { Textarea } from "@/components/ui/textarea";
import { CheckCircle2 } from "lucide-react";

export const EditableList = ({ items = [], editing, onChange, testId, accent = "text-emerald-400" }) => {
  if (editing) {
    return (
      <Textarea data-testid={`${testId}-input`} rows={Math.max(4, items.length + 1)} value={items.join("\n")}
        onChange={(e) => onChange(e.target.value.split("\n"))}
        className="bg-slate-950/60 border-slate-700 text-sm" placeholder="One item per line" />
    );
  }
  return (
    <ul className="space-y-2" data-testid={testId}>
      {items.filter(Boolean).map((it, i) => (
        <li key={i} className="flex gap-2 text-sm text-slate-300 leading-relaxed">
          <CheckCircle2 className={`h-4 w-4 mt-0.5 shrink-0 ${accent}`} />{it}
        </li>
      ))}
    </ul>
  );
};
